import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import "./MCAProgram.css"; 
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

// Icons remain the same
const CalendarIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><rect x="3.5" y="5.5" width="17" height="15" rx="3" /><path d="M7.5 3.5v4" /><path d="M16.5 3.5v4" /><path d="M3.5 9.5h17" /><path d="M8 13h3" /><path d="M13 13h3" /><path d="M8 17h3" /></svg>);
const VerifiedIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><path d="M12 3.5 18.5 6v5.5c0 4.2-2.5 7.2-6.5 9-4-1.8-6.5-4.8-6.5-9V6L12 3.5Z" /><path d="m9.2 12.3 1.9 1.9 3.9-4.2" /></svg>);
const SettingsIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><circle cx="12" cy="12" r="3.2" /><path d="M19.4 15a1 1 0 0 0 .2 1.1l.1.1a1.8 1.8 0 1 1-2.5 2.5l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V20a1.8 1.8 0 1 1-3.6 0v-.2a1 1 0 0 0-.7-.9 1 1 0 0 0-1.1.2l-.1.1a1.8 1.8 0 1 1-2.5-2.5l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H4a1.8 1.8 0 1 1 0-3.6h.2a1 1 0 0 0 .9-.7 1 1 0 0 0-.2-1.1l-.1-.1a1.8 1.8 0 1 1 2.5-2.5l.1.1a1 1 0 0 0 1.1.2h.1a1 1 0 0 0 .6-.9V4a1.8 1.8 0 1 1 3.6 0v.2a1 1 0 0 0 .7.9 1 1 0 0 0 1.1-.2l.1-.1a1.8 1.8 0 1 1 2.5 2.5l-.1.1a1 1 0 0 0-.2 1.1v.1a1 1 0 0 0 .9.6H20a1.8 1.8 0 1 1 0 3.6h-.2a1 1 0 0 0-.9.7Z" /></svg>);
const TrendingIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><path d="M4 16.5 9 11.5l3.2 3.2L20 7" /><path d="M14 7h6v6" /></svg>);
const HubIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><circle cx="12" cy="5" r="2.3" /><circle cx="5" cy="17" r="2.3" /><circle cx="19" cy="17" r="2.3" /><path d="M12 7.3v4.2" /><path d="M12 11.5 6.8 14.6" /><path d="M12 11.5l5.2 3.1" /></svg>);
const BuildingIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg"><path d="M3 21h18M5 21V7l7-3 7 3v14M8 10h2m-2 4h2m-2 4h2m4-8h2m-4 4h2m-4 4h2" /></svg>);
const UsersIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm14 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>);
const GraduationIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" /></svg>);

export default function ProfessionalMCAProgram() {
  const [showForm, setShowForm] = useState(false);
  
  // --- ADDED SAFE ASSET HELPER FUNCTION ---
  const asset = (path) => `${process.env.PUBLIC_URL || ''}${path.startsWith('/') ? path : `/${path}`}`;
  
  const highlights = [
    { title: "Flexible Learning Schedule", desc: "Hybrid delivery with evening and weekend sessions, designed to suit the needs of working professionals.", icon: <CalendarIcon /> },
    { title: "Industry-Focused Curriculum", desc: "Learn the latest IT concepts, tools, and practices that align with evolving industry trends and digital transformation needs.", icon: <SettingsIcon /> },
    { title: "Career Advancement", desc: "Enhance your professional profile and unlock leadership and higher earning opportunities in the technology sector.", icon: <TrendingIcon /> },
    { title: "Networking Opportunities", desc: "Collaborate with a diverse peer group of professionals and gain exclusive access to the TIMSCDR Alumni Network.", icon: <HubIcon /> },
    { title: "Holistic Skill Development", desc: "Strengthen both technical and managerial capabilities, preparing for impactful roles in software development, systems management, and IT consulting.", icon: <VerifiedIcon /> },
  ];

  return (
    <>
      <Navbar />
      <CTAButtons />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <PageHeader
        title="MCA Working Professionals"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'MCA Working Professionals' }]}
      />
      <div className="mca-page-bg">
        <div className="mca-ig-wrapper">
          <div className="mca-ig-container">
            <div className="mca-ig-overview-card">
              <div className="mca-ig-image-box">
                {/* --- FIXED PATH FOR LIVE SERVER: Capital 'P' in Program --- */}
                <img
                  src={asset('/Program/WP.webp')}
                  alt="Working Professionals"
                  className="mca-ig-hero-img"
                />
                <div className="mca-ig-image-overlay">
                  <div className="mca-ig-image-overlay-content">
                    <h3>Program Overview</h3>
                    <p>Advanced learning for professionals.</p>
                  </div>
                </div>
              </div>

              <div className="mca-ig-text-content">
                <p className="mca-ig-para">
                  The MCA for Working Professionals is a two-year postgraduate program for individuals looking to advance their careers while continuing their employment. The programme is affiliated with the University of Mumbai and approved by AICTE and DTE, Govt of Maharashtra. It is offered in a hybrid mode with evening and weekend classes. It focuses on core areas of computer applications through a curriculum that combines academic learning with practical industry exposure.
                </p>
              </div>
            </div>

            <div className="mca-ig-grid">
              {highlights.map((feature, index) => (
                <div key={index} className="mca-ig-card">
                  <div className="mca-ig-icon-wrapper">{feature.icon}</div>
                  <div className="mca-ig-card-info">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mca-ig-stats-row">
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper"><BuildingIcon /></div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">2025–26</span>
                <span className="mca-ig-stat-label">Establishment</span>
              </div>
            </div>
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper"><UsersIcon /></div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">60</span>
                <span className="mca-ig-stat-label">Annual Intake</span>
              </div>
            </div>
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper"><GraduationIcon /></div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">Postgraduate</span>
                <span className="mca-ig-stat-label">Program Level</span>
              </div>
            </div>
          </div>
        </div>
        <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      </div>
      <Footer />
    </>
  );
}